import React, { useEffect, useState } from "react";
import "./styles/index.less";
import {
  Button,
  Row,
  Col,
  Layout,
  Form,
  message,
  Typography,
  Select,
  Steps,
  Popconfirm,
  Modal,
  Breadcrumb,
} from "antd";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import InformationPage from "./component/InformationPage";
import ResourcePage from "./component/ResourcePage";
import DatasetPage from "./component/DatasetPage";
import EvaluationPage from "./component/EvaluationPage";
import SponsorPage from "./component/SponsorPage";
import {
  get_task_by_id,
  task_create,
  task_delete,
  task_drop,
  task_update,
} from "../../services/task";
import { upload_file } from "../../services/uploads";
import { setting_all } from "../../services/setting";
import Timeline from "./component/Timeline";
import { get_all_category } from "../../services/category";
import { task_register } from "../../services/task_member";
import { team_create } from "../../services/team";

dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);

type Props = {};

const ConfigTaskmainpage = (props: Props) => {
  const { t } = useTranslation();
  const params = useParams();
  const auth = useAuth();
  const [form] = Form.useForm();
  const [task_id_inform, setTask_id_inform] = useState(
    form.getFieldValue("task_id"),
  );
  const navigate = useNavigate();

  const [current, setCurrent] = useState(0);
  const [taskIdOnCreate, setTaskIdOnCreate] = useState<string | null>(null);
  const [imageUrluse, setImageUrluse] = useState<File | null>(null);

  //steps
  const steps = [
    {
      title: t("Information"),
      content: (
        <InformationPage
          params={params}
          setImageUrluse={setImageUrluse}
          form={form}
        />
      ),
    },
    {
      title: t("Resource"),
      content: <ResourcePage form={form} />,
    },
    {
      title: t("Dataset"),
      content: <DatasetPage form={form} task_id={task_id_inform} />,
    },
    {
      title: t("Evaluation"),
      content: <EvaluationPage form={form} />,
    },
    {
      title: t("Timeline"),
      content: <Timeline form={form} />,
    },

    {
      title: t("Sponsor"),
      content: <SponsorPage form={form} />,
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const handleChangeSteps = (value: number) => {
    setCurrent(value);
  };

  const handleDeleteEvent = async (task_id: string) => {
    try {
      await task_drop({ task_id: task_id });
      message.info("Task ถูกยกเลิกเรียบร้อยแล้ว");
    } catch (e) {
      console.error("ลบ Task ไม่สำเร็จ:", e);
      message.error("ไม่สามารถยกเลิก Task ได้");
    }
  };

  const createEvent = async (value: any) => {
    // setSubmitting(true);
    try {
      let uploadedImgUrl = null;
      if (imageUrluse) {
        try {
          const uploadResponse = await upload_file({
            task_id: "img_task",
            type: "task_logo",
            name: imageUrluse.name,
            file: imageUrluse,
          });

          if (uploadResponse.status === "success") {
            uploadedImgUrl = uploadResponse.link;
          } else {
            throw new Error("Failed to upload image.");
          }
        } catch (uploadError) {
          console.error("Error uploading image:", uploadError);
          message.error("Failed to upload image.");
          // setSubmitting(false);
          return;
        }
      }
      const form_result = [
        {
          information: value.information,
          datasetdetail: value.datasetdetail,
          submission: value.submission,
          evaluation: value.evaluation,
          rules: value.rules,
        },
      ];

      const res = await task_create({
        data: {
          user_id: auth.user.user_id,
          task_id: value.task_id, //task_id: form.getFieldValue("Codename"),
          name: value.name, //form.getFieldValue("nametask"),
          information: form_result,
          type: value.type,
          status: params.action === "create" ? 99 : 1,
          img:
            uploadedImgUrl ||
            "https://thumb.ac-illust.com/b1/b170870007dfa419295d949814474ab2_t.jpeg",
          tags: JSON.stringify(value.tags) || JSON.stringify([]),

          created_by: auth.user.user_id,
          team_size: value.team_size,
          min_size: value.min_size,
          teamname_regex: value.teamname_regex,
        },
      });
      setTaskIdOnCreate(form.getFieldValue("task_id"));
      if (res.status === "failed") {
        message.warning("Duplicate task!");
        return res;
      }
      await task_register({
        user_id: auth.user.user_id,
        task_id: value.task_id,
        role: 2,
      });
      await team_create({
        task_id: value.task_id,
        team_name: "Admin Team",
        user_id: [auth.user.user_id],
      });
      message.success("Create Success!");
      return res;
    } catch (e) {
      console.error(e);
    }
    // setSubmitting(false);
  };

  const createAll = async () => {
    try {
      const result = form.getFieldsValue(true);
      let uploadedImgUrl = null;
      if (imageUrluse) {
        try {
          const uploadResponse = await upload_file({
            task_id: "img_task",
            type: "task_logo",
            name: imageUrluse.name,
            file: imageUrluse,
          });

          if (uploadResponse.status === "success") {
            uploadedImgUrl = uploadResponse.link;
          } else {
            throw new Error("Failed to upload image.");
          }
        } catch (uploadError) {
          console.error("Error uploading image:", uploadError);
          message.error("Failed to upload image.");
          // setSubmitting(false);
          return;
        }
      }

      //set data resources
      // const resources = {
      //   resource: {
      //     task: result.hostname
      //       ? [
      //           {
      //             id: result.preset,
      //             preset: result.preset,
      //             ip: result.ip,
      //             hostname: result.hostname,
      //             cpu: result.cpu,
      //             gpu: result.gpu,
      //             ram: result.ram || null,
      //             imgdockertimeout: result.imgdockertimeout,
      //           },
      //         ]
      //       : [], // ✅ ถ้าไม่มี hostname → ให้เป็น `[]`
      //     evaluation: result.hostnameevaluation
      //       ? [
      //           {
      //             id: result.preseteval,
      //             preset: result.preseteval,
      //             ip: result.ip_eval,
      //             hostname: result.hostnameevaluation,
      //             cpu: result.cpueva.map((item: any) => ({
      //               cpu: item.cpueva || "",
      //               core: item.coreeva || 0,
      //             })),
      //             gpu: result.gpueva.map((item: any) => ({
      //               gpu: item.gpueva,
      //               card: item.cardeva,
      //             })),
      //             ram: result.rameva || null,
      //             imgdockertimeout: result.imgdockertimeouteva,
      //           },
      //         ]
      //       : [], // ✅ ถ้าไม่มี hostnameevaluation → ให้เป็น `[]`

      //     imgdocker: null,
      //   },
      // };
      const resources = {
        resource: {
          task:
            result.submissiontype == 1
              ? result?.tasks.map((item: any) => {
                  return {
                    id: item.preset,
                    preset: item.preset,
                    ip: item.ip,
                    hostname: item.hostname,
                    cpu: item.cpu,
                    gpu: item.gpu,
                    ram: item.ram || null,
                    imgdockertimeout: item.imgdockertimeout,
                  };
                }) || []
              : [], // ✅ ถ้าไม่มี hostname → ให้เป็น `[]`
          evaluation:
            result?.evaluations.map((item: any) => {
              return {
                id: item.preset,
                preset: item.preset,
                ip: item.ip_eval,
                hostname: item.hostnameevaluation,
                cpu: item.cpueva.map((child: any) => ({
                  cpu: child.cpueva || "",
                  core: child.coreeva || 0,
                })),
                gpu: item.gpueva.map((child: any) => ({
                  gpu: child.gpueva,
                  card: child.cardeva,
                })),
                ram: item.rameva || null,
                imgdockertimeout: item.imgdockertimeouteva,
              };
            }) || [],
          imgdocker: null,
        },
      };

      console.log("result:", result);
      console.log("resources:", resources);
      // set data dataset
      const dataset = {
        dataset: {
          public: result.datasetpublic,
          private: result.datasetprivate,
        },
      };
      // set data eva
      const evaluation = {
        evaluation: {
          public: [
            {
              link: result.evaluationPublic || "", // ใช้ค่าจากฟอร์ม
            },
          ],
          private: [
            {
              link: result.evaluationprivate || "", // ใช้ค่าจากฟอร์ม
            },
          ],
        },
      };
      const form_result = [
        {
          information: result.information,
          datasetdetail: result.datasetdetail,
          submission: result.submission,
          evaluation: result.evaluation,
          rules: result.rules,
        },
      ];
      // set all event datetime
      const all_date = [
        {
          result_date: form.getFieldValue("resultdate")
            ? dayjs(form.getFieldValue("resultdate")).format("YYYY-MM-DD") +
              " " +
              (form.getFieldValue("timeresult") || "00:00:00")
            : null,
          start_date: form.getFieldValue("startdate")
            ? dayjs(form.getFieldValue("startdate")).format("YYYY-MM-DD") +
              " " +
              (form.getFieldValue("timestart") || "00:00:00")
            : null,
          end_date: form.getFieldValue("enddate")
            ? dayjs(form.getFieldValue("enddate")).format("YYYY-MM-DD") +
              " " +
              (form.getFieldValue("timeend") || "00:00:00")
            : null,
          award_date: form.getFieldValue("awarddate")
            ? dayjs(form.getFieldValue("awarddate")).format("YYYY-MM-DD") +
              " " +
              (form.getFieldValue("timeaward") || "00:00:00")
            : null,
          // ============
          start_event_date: form.getFieldValue("startevent")
            ? dayjs(form.getFieldValue("startevent")).format("YYYY-MM-DD") +
              " " +
              (form.getFieldValue("timestartevent") || "00:00:00")
            : null,
          start_regis_date: form.getFieldValue("startregis")
            ? dayjs(form.getFieldValue("startregis")).format("YYYY-MM-DD") +
              " " +
              (form.getFieldValue("timestartregis") || "00:00:00")
            : null,
          end_regis_date: form.getFieldValue("endregis")
            ? dayjs(form.getFieldValue("endregis")).format("YYYY-MM-DD") +
              " " +
              (form.getFieldValue("timeendregis") || "00:00:00")
            : null,
        },
      ];

      const form_img = form.getFieldValue("img");
      const def_img =
        "https://thumb.ac-illust.com/b1/b170870007dfa419295d949814474ab2_t.jpeg";

      const data = {
        ...result,
        //
        result_date: null,
        start_date: null,
        end_date: null,
        award_date: null,
        //
        img: uploadedImgUrl
          ? uploadedImgUrl
          : form_img == def_img
            ? null
            : form_img,
        // img:
        //   uploadedImgUrl ||
        //   "https://thumb.ac-illust.com/b1/b170870007dfa419295d949814474ab2_t.jpeg",
        // =======information page============
        tags: JSON.stringify(result.tags),
        // ============Resource page================
        image_cleanup_date: form.getFieldValue("imgdocker")
          ? dayjs(form.getFieldValue("imgdocker")).format("YYYY-MM-DD") +
            " " +
            (form.getFieldValue("timeimagedocker") || "00:00:00")
          : null,
        resources: resources,
        // ============dataset page===============
        dataset: dataset,
        // ============evaluation page===========
        evaluation_script: JSON.stringify(evaluation),
        metrics: result.metrics,
        submission_type: result.submissiontype,
        // ============more detail page===========
        // ============sponsor page===========
        sponsors: result.sponsor || [],
        status: 1,
        submissiontypedate: result.submissiontypedate,
        submission_time: {
          date: dayjs(result.date_start_task).format("DD-MM-YYYY"),
          day: result.day_start_task,
          time: result.time_start_task || "00:00:00",
        },
        // event timeline
        event_date: all_date,
        information: JSON.stringify(form_result),
      };
      const res = await task_update({ data }); // เรียก API
      if (res.status === "success") {
        if (params.action === "create") {
          message.success("Create Success!");
        } else if (params.action === "edit") {
          message.success("Update Success!");
        }
      } else {
        message.error(
          params.action === "create"
            ? "Failed to create data."
            : "Failed to update data.",
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleNextSteps = async () => {
    try {
      const values = await form.validateFields();
      if (params.action === "create") {
        if (current === 0) {
          // บันทึกหน้าแรกในโหมด create
          // await createEvent(values);
          // form.submit();
          const eventResponse = await createEvent(values);
          if (eventResponse?.status === "failed") {
            return; // ❌ หยุดการทำงาน ไม่เปลี่ยนหน้า
          }
        }
        if (current === steps.length - 1) {
          // บันทึกทั้งหมดในโหมด create
          await createAll();
        }
      } else if (params.action === "edit") {
        if (current === steps.length - 1) {
          // บันทึกทั้งหมดในโหมด edit
          await createAll();
        }
      }
      if (current < steps.length - 1) {
        setCurrent(current + 1);
      }
    } catch (errorInfo) {
      console.error("Failed to proceed:", errorInfo);
    }
  };

  const handlePrevSteps = async (task_id: string) => {
    if (params.action === "edit") {
      // ถ้า action เป็น edit ให้ถอยหลังอย่างเดียว
      if (current > 0) {
        setCurrent((prevCurrent) => prevCurrent - 1);
      }
    } else {
      if (current > 0) {
        setCurrent((prevCurrent) => prevCurrent - 1);
      }
      if (current === 1) {
        try {
          await task_delete({ task_id });
        } catch (error) {
          console.error("Failed to delete task:", error);
        }
      }
    }
  };

  const getEditTask = async () => {
    const res = await get_task_by_id({ task_id: params.task_id });
    // ===========
    const list_tags = await get_all_category();
    // const category = list_tags.result.map((item: any) => item.name);
    const category = list_tags.result.map((item: any) => item.category_id);
    // ===========
    const data_task: any = res.result[0];
    const config_system: any = await setting_all();
    const configs_data: any = JSON.parse(config_system.data[0].configs);
    const resourcesuse: any = res.result[0]?.resources
      ? JSON.parse(res.result[0]?.resources)
      : {};
    const data_set: any = JSON.parse(data_task?.dataset || null);
    const evaluation_script: any = JSON.parse(
      data_task?.evaluation_script || null,
    )?.evaluation;
    const metrics_data = JSON.parse(data_task?.metrics || null);
    const sponsors = JSON.parse(data_task?.sponsors || "[]");
    const rawValue = data_task?.information;
    let data_editor: any = [];
    if (data_task?.information == null) {
      data_editor = [];
    } else if (
      typeof rawValue === "string" &&
      (rawValue?.trim().startsWith("[") || rawValue?.trim().startsWith("{"))
    ) {
      try {
        data_editor = JSON.parse(rawValue);
        // กรณี parse ออกมาแล้วเป็น object เดียว ไม่ใช่ array (ถ้า db เก็บหลายท่า)
        if (!Array.isArray(data_editor)) {
          data_editor = [data_editor];
        }
      } catch (e) {
        data_editor = [{ information: rawValue }];
      }
    } else {
      data_editor = [{ information: rawValue }];
    }

    const formattedResources = (resourcesuse?.resource?.task || []).map(
      (task: any) => ({
        id: task?.id || null,
        preset: task?.preset,
        ip: task?.ip,
        hostname: task?.hostname,
        cpu: (task.cpu || []).map((c: any) => ({
          cpu: c.cpu || "",
          core: c.core || 0,
        })),
        gpu: (task.gpu || [])
          .map((g: any) => {
            let checkdup_card = g.card?.toString().split(",");
            if (checkdup_card?.length > 1) {
              const new_arr_card = checkdup_card.map((item: any) => ({
                gpu: g.gpu || "",
                card: item,
              }));
              return new_arr_card;
            } else {
              return {
                gpu: g.gpu || "",
                card: g.card,
              };
            }
          })
          .flat(),
        ram: task.ram || 0,
        imgdockertimeout: task.imgdockertimeout || undefined,
      }),
    );
    console.log("formattedResources", formattedResources);
    const formattedResourceEvaluation = (
      resourcesuse.resource?.evaluation || []
    ).map((evaluation: any) => ({
      id: evaluation?.id || null,
      preset: evaluation?.preset,
      ip: evaluation?.ip,
      hostnameevaluation: evaluation?.hostname || "",
      cpueva: (evaluation.cpu || []).map((c: any) => ({
        cpueva: c.cpu || "",
        coreeva: c.core || 0,
      })),
      gpueva: (evaluation.gpu || [])
        .map((g: any) => {
          let checkdup_card = g.card?.toString().split(",");
          if (checkdup_card?.length > 1) {
            const new_arr_card = checkdup_card.map((item: any) => ({
              gpueva: g.gpu || "",
              cardeva: item,
            }));
            return new_arr_card;
          } else {
            return {
              gpueva: g.gpu || "",
              cardeva: g.card,
            };
          }
        })
        .flat(),
      rameva: evaluation.ram || 0,
      imgdockertimeouteva: evaluation.imgdockertimeout || undefined,
    }));
    console.log("formattedResourceEvaluation", formattedResourceEvaluation);

    let timesubmission_start = {};
    const looksLikeJSON = data_task.submission_time?.trim().startsWith("{");
    let time_setup_parse = looksLikeJSON
      ? JSON.parse(data_task.submission_time) || null
      : { time: data_task.submission_time };

    if (data_task.submission_typedate == 1) {
      timesubmission_start = {
        time_start_task:
          data_task.submission_time == null
            ? configs_data.time_start_task
            : time_setup_parse.time,
      };
    } else if (data_task.submission_typedate == 2) {
      timesubmission_start = {
        day_start_task:
          data_task.submission_time == null
            ? configs_data.time_start_task
            : time_setup_parse.day,
        time_start_task:
          data_task.submission_time == null
            ? configs_data.time_start_task
            : time_setup_parse.time,
      };
    } else if (data_task.submission_typedate == 3) {
      timesubmission_start = {
        date_start_task:
          data_task.submission_time == null
            ? configs_data.time_start_task
            : dayjs(time_setup_parse.date, "DD-MM-YYYY"),
        time_start_task:
          data_task.submission_time == null
            ? configs_data.time_start_task
            : time_setup_parse.time,
      };
    }

    let event_date = JSON.parse(data_task.event_date) || [];
    console.log("data_task:", data_task);
    console.log("formattedResources:", formattedResources);
    form.setFieldsValue({
      ...data_task,
      // ข้างล่างอาจจะไม่ได้กำหนดทุกตัวแต่จัดการให้ข้อมูลบางตัวตรงกับชื่อ form
      // =========information page=========
      tags:
        JSON.parse(data_task?.tags)?.filter((i: any) => category.includes(i)) ||
        [],
      startdate: data_task?.start_date
        ? dayjs(data_task?.start_date, "YYYY-MM-DD HH:mm:ss").add(7, "hour")
        : event_date[0]?.start_date
          ? dayjs(event_date[0]?.start_date)
          : null,
      enddate: data_task?.end_date
        ? dayjs(data_task?.end_date, "YYYY-MM-DD HH:mm:ss").add(7, "hour")
        : event_date[0]?.end_date
          ? dayjs(event_date[0]?.end_date)
          : null,
      awarddate: data_task?.award_date
        ? dayjs(data_task?.award_date, "YYYY-MM-DD HH:mm:ss").add(7, "hour")
        : event_date[0]?.award_date
          ? dayjs(event_date[0]?.award_date)
          : null,
      resultdate: data_task?.result_date
        ? dayjs(data_task?.result_date, "YYYY-MM-DD HH:mm:ss").add(7, "hour")
        : event_date[0]?.result_date
          ? dayjs(event_date[0]?.result_date)
          : null,
      // ==============
      timestart: data_task?.start_date
        ? dayjs(data_task?.start_date).format("HH:mm:ss")
        : event_date[0]?.start_date
          ? dayjs(event_date[0]?.start_date).format("HH:mm:ss")
          : "00:00:00",
      timeend: data_task?.end_date
        ? dayjs(data_task?.end_date).format("HH:mm:ss")
        : event_date[0]?.end_date
          ? dayjs(event_date[0]?.end_date).format("HH:mm:ss")
          : "00:00:00",
      timeresult: data_task?.result_date
        ? dayjs(data_task?.result_date).format("HH:mm:ss")
        : event_date[0]?.result_date
          ? dayjs(event_date[0]?.result_date).format("HH:mm:ss")
          : "00:00:00",
      timeaward: data_task?.award_date
        ? dayjs(data_task?.award_date).format("HH:mm:ss")
        : event_date[0]?.award_date
          ? dayjs(event_date[0]?.award_date).format("HH:mm:ss")
          : "00:00:00",
      // ==========new time===============
      timestartevent: event_date[0]?.start_event_date
        ? dayjs(event_date[0]?.start_event_date).format("HH:mm:ss")
        : "00:00:00",
      startevent: event_date[0]?.start_event_date
        ? dayjs(event_date[0]?.start_event_date, "YYYY-MM-DD HH:mm:ss")
        : null,
      timestartregis: event_date[0]?.start_regis_date
        ? dayjs(event_date[0]?.start_regis_date).format("HH:mm:ss")
        : "00:00:00",
      startregis: event_date[0]?.start_regis_date
        ? dayjs(event_date[0]?.start_regis_date, "YYYY-MM-DD HH:mm:ss")
        : null,
      timeendregis: event_date[0]?.end_regis_date
        ? dayjs(event_date[0]?.end_regis_date).format("HH:mm:ss")
        : "00:00:00",
      endregis: event_date[0]?.end_regis_date
        ? dayjs(event_date[0]?.end_regis_date, "YYYY-MM-DD HH:mm:ss")
        : null,
      //=========resource page=========
      //resource task
      // preset: formattedResources[0]?.id,
      preset: formattedResources[0]?.preset,
      ip: formattedResources[0]?.ip,
      hostname: formattedResources[0]?.hostname,
      cpu: formattedResources[0]?.cpu || [],
      gpu: formattedResources[0]?.gpu || [],
      ram: formattedResources[0]?.ram || 0,
      imgdockertimeout: formattedResources[0]?.imgdockertimeout,
      //resource eval
      preseteval: formattedResourceEvaluation[0]?.preset,
      ip_eval: formattedResourceEvaluation[0]?.ip,
      hostnameevaluation:
        formattedResourceEvaluation[0]?.hostnameevaluation || "",
      cpueva: formattedResourceEvaluation[0]?.cpueva || "",
      gpueva: formattedResourceEvaluation[0]?.gpueva || "",
      rameva: formattedResourceEvaluation[0]?.rameva || 0,
      imgdockertimeouteva: formattedResourceEvaluation[0]?.imgdockertimeouteva,
      imgdockereva: formattedResourceEvaluation[0]?.imgdockereva,
      //
      image_cleanup_date: data_task.image_cleanup_date
        ? dayjs(data_task.image_cleanup_date, "YYYY-MM-DD HH:mm:ss")
        : null,
      //======dataset page=========
      datasetpublic: data_set?.dataset?.public
        ? data_set.dataset?.public.map((item: any) => ({
            name: item.name || "",
            desciption: item.desciption || "",
            link: item.link || "",
            samples: item.samples || 0,
          }))
        : [],
      datasetprivate: data_set?.dataset?.private
        ? data_set.dataset?.private.map((item: any) => {
            return {
              name: item.name || "",
              desciption: item.desciption || "",
              link: item.link || "",
              samples: item.samples || 0,
            };
          })
        : [],
      //======evalution page=========
      ...timesubmission_start,
      // time_start_task:
      //   data_task.submission_time == null
      //     ? configs_data.time_start_task
      //     : data_task.submission_time,
      evaluationPublic: evaluation_script.public[0].link || "",
      evaluationprivate: evaluation_script.private[0].link || "",
      metrics: metrics_data || [],
      submissiontypedate: data_task.submission_typedate || 1,
      submissiontype: data_task.submission_type || 1,
      submission_file_name: data_task.submission_file_name || "",
      submission_file_type: data_task.submission_file_type || "",
      //======more detail page=========
      award: JSON.parse(data_task.award) || [{ name: "", award: "" }],
      //======sponsor page=========
      sponsor: sponsors.map((sponsor: any) => ({
        logo: sponsor.logo || "",
        name: sponsor.name || "",
        url: sponsor.url || "",
      })),
      ...data_editor[0],
      currentPreset: formattedResources.length != 0 ? true : false,
      currentPresetEval: formattedResourceEvaluation.length != 0 ? true : false,

      // ชชชชชชชชชชชชชชชชชชชชชชชชชชชชชช
      tasks: formattedResources.map((resource: any) => ({
        preset: resource.preset_id || resource.id, // ใช้ ID เพื่อให้ Select จับคู่ได้
        hostname: resource.hostname,
        ip: resource.ip,
        cpu: resource.cpu || [],
        gpu: resource.gpu || [],
        ram: resource.ram || 0,
        imgdockertimeout: resource.imgdockertimeout || 2,
      })),

      // 2. ส่วนของ Evaluation Machines (แยกออกมาเป็นอีก Key หนึ่ง)
      evaluations: formattedResourceEvaluation.map((evalData: any) => ({
        preset: evalData.preset_id || evalData.id,
        hostnameevaluation: evalData.hostnameevaluation || "",
        ip_eval: evalData.ip || "",
        cpueva: evalData.cpueva || [], // ต้องเป็น Array ของ Object [{ cpueva: '...', coreeva: ... }]
        gpueva: evalData.gpueva || [], // ต้องเป็น Array ของ Object [{ gpueva: '...', cardeva: ... }]
        rameva: evalData.rameva || 0,
        imgdockertimeouteva: evalData.imgdockertimeouteva || 2,
        imgdockereva: evalData.imgdockereva || "",
      })),
    });
    try {
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (params.action == "edit") {
      getEditTask();
      // task_id_inform = params.task_id;
    }
  }, []);

  useEffect(() => {
    setTask_id_inform(params.task_id);
  }, [params]);

  return (
    <div className="add-task-layout">
      <Form
        layout="vertical"
        onFinish={(value) => {
          if (params.action === "create" && current === 0) {
            createEvent(value);
            window.scrollTo(0, 0);
            navigate("/task");
          } else {
            createAll();
          }
        }}
        // onFinish={createAll}
        form={form}
        initialValues={{ type: 2, imgdockertimeout: 2, imgdockertimeouteva: 2 }}
        onFinishFailed={(e) => console.error(e)}
      >
        <div style={{ marginBottom: 20 }}>
          <Row justify="space-between" align="middle">
            <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>
                      {params.action === "create"
                        ? t("Add Task")
                        : `${t("Edit Task")} (${params.task_id})`}
                    </span>
                  ),
                },
              ]}
            />
          </Row>
          <hr />
        </div>
        <div>
          <Steps
            current={current}
            onChange={(next) => {
              if (
                params.action === "edit" &&
                form.isFieldsTouched() &&
                form.getFieldsError().some((field) => field.errors.length > 0)
              ) {
                Modal.warning({
                  title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                  content: "คุณต้องกรอกข้อมูลให้ครบถ้วนก่อนที่จะไปยังหน้าถัดไป",
                });
                return;
              }
              if (params.action === "edit") {
                handleChangeSteps(next);
              }
            }}
            items={items}
            type="navigation"
          />

          <div>{steps[current].content}</div>
        </div>

        <div>
          <Row
            justify="space-between"
            align="middle"
            className="add-task-buttom-layout"
          >
            {/* Previous Button */}
            <Col>
              <div
                style={{
                  marginTop: 24,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {current > 0 && (
                  <Button onClick={() => handlePrevSteps(task_id_inform)}>
                    {t("Previous")}
                  </Button>
                )}
              </div>
            </Col>

            {/* Next, Cancel, Create / Update Task */}
            <Col>
              <Row>
                <div
                  style={{
                    marginTop: 24,
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: "10px",
                  }}
                >
                  <Col>
                    <Popconfirm
                      key={params.action}
                      title={`${t("Are you sure you want to")} ${
                        params.action === "create"
                          ? t("cancel the create of this event")
                          : t("cancel edit this activity")
                      }`}
                      description={`${t("If")} ${
                        params.action === "create"
                          ? t("cancel, the created activity will be deleted")
                          : t(
                              "no activity is edited, the system will go to the All Activity Data page",
                            )
                      }`}
                      okText={t("confirm")}
                      cancelText={t("cancel")}
                      onConfirm={async () => {
                        if (params.action === "create" && taskIdOnCreate) {
                          await handleDeleteEvent(taskIdOnCreate);
                        }
                        window.scrollTo(0, 0);
                        navigate("/task");
                      }}
                    >
                      <Button>{t("cancel")}</Button>
                    </Popconfirm>
                  </Col>
                  {/* Next Button (แสดงทุกหน้าที่ยังไม่ใช่หน้าสุดท้าย) */}
                  {current < steps.length - 1 && (
                    <Col>
                      <Button
                        type="primary"
                        onClick={() => {
                          handleNextSteps();
                          window.scrollTo(0, 0);
                        }}
                      >
                        {t("Next")}
                      </Button>
                    </Col>
                  )}

                  <Col>
                    <Popconfirm
                      title={`${t("Are you sure you want to")} ${
                        params.action === "create"
                          ? t("create task")
                          : t("update task")
                      }`}
                      description={t("Please confirm before proceeding")}
                      okText={t("confirm")}
                      cancelText={t("cancel")}
                      onConfirm={() => {
                        try {
                          form.submit();
                        } catch (e) {
                          console.error(e);
                        }
                      }}
                    >
                      <Button
                        type="primary"
                        // loading={loading}
                      >
                        {params.action === "create"
                          ? t("Create Task")
                          : t("Update Task")}
                      </Button>
                    </Popconfirm>
                  </Col>
                </div>
              </Row>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
};

export default ConfigTaskmainpage;
